console.log("recently-viewed.js");
console.log("------------------");
if (!customElements.get("recently-viewed")) {
  customElements.define(
    "recently-viewed",
    class ProductRecentlyViewed extends HTMLElement {
      constructor() {
        super();
        this.howManyToStore = 5;
        this.cookieName = "WWF_recently_viewed";
        this.cookieOptions = {
          expires: 90,
          path: '/',
          domain: window.location.hostname
        }
        this.myelement = document.querySelector('recently-viewed ul')
        this.init();
      }

      connectedCallback() {
        console.log("connectedCallback() called")
        const rp = this.readCookie();
        rp.forEach((i) => {
          const u = '/products/' + i + '.js';
          this.fetchItem(u)
        });
      }

      fetchItem(url) {
        fetch(url)
          .then((response) => response.json())
          .then((json) => {
            console.log(json.handle, json.id);
            this.buildElement(json);
          })
          .catch((e) => {
            console.error(e)
          });
      }

      buildElement(data) {
        const html = document.createElement('li');
        html.classList.add('grid__item');
        const output = `
        <div class="card-wrapper product-card-wrapper underline-links-hover">
          <div class="card card--standard card--media" style="--ratio-percent: 100%;">
            <div class="card__inner color-background-2 gradient ratio" style="--ratio-percent: 100%;">
            <div class="card__media">
              <div class="media media--transparent media--hover-effect">
              <img src="${data.featured_image}&amp;width=300" style="max-width:100%;" alt="${data.title}"/>
              </div>
            </div>
            </div>
            <div class="card__content">
            <div class="card__information">
              <h3 class="card__heading h5">
                <a href="/products/${data.handle}" class="full-unstyled-link">${data.title}</a>
              </h3>
            </div>
            
            </div>
          </div>
        </div>
        `;
        html.innerHTML = output;
        this.myelement.append(html);
      }

      getProductHandle() {
        if (window.location.pathname.indexOf('/products/') !== -1) {
          return window.location.pathname.match(/\/products\/([a-z0-9\-]+)/)[1];
        }
      }

      init() {
        console.log("init() called")
        if(Cookies.get(this.cookieName) == undefined) {
          Cookies.set(this.cookieName, JSON.stringify([]), this.cookieOptions)
        }
        this.recordRecentlyViewed();
      }

      readCookie() {
        return JSON.parse(Cookies.get(this.cookieName));
      }

      recordRecentlyViewed() {
        console.log("recordRecentlyViewed() called");
        let recentlyviewed = this.readCookie();
        const handle = this.getProductHandle();
        const position = recentlyviewed.indexOf(handle);
        if (position === -1) {
          recentlyviewed.unshift(handle);
          recentlyviewed = recentlyviewed.splice(0, this.howManyToStore);
        } else {
          recentlyviewed.splice(position, 1);
          recentlyviewed.unshift(handle);
        }
        Cookies.set(this.cookieName, JSON.stringify(recentlyviewed), this.cookieOptions);
      }
    }
  );
}
